import { IConstants } from '../models/pro-sites';

export const getConstants = (): Promise<IConstants> => {
    return new Promise((resolve) => {
        (function waitForConstants() {
            if (window.constants) {
                return resolve(window.constants);
            }
            setTimeout(waitForConstants, 100);
        })();
    });
};
